import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/admin/perfiles'
    { path: '', pathMatch: 'full', redirectTo: 'admin/perfiles' },

    // Redirect signed in user to the '/admin/proveedores'
    //
    // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'admin/perfiles' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: '404', loadChildren: () => import('app/modules/errors/404/404.routes') },
            { path: '403', loadChildren: () => import('app/modules/errors/403/403.routes') },
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            // Admin
            { path: 'admin/colaboradores', loadChildren: () => import('app/modules/intranet/admin/colaboradores/colaboradores.routes') },
            { path: 'admin/departamentos', loadChildren: () => import('app/modules/intranet/admin/departamentos/departamentos.routes') },
            { path: 'admin/perfiles', loadChildren: () => import('app/modules/intranet/admin/perfiles/profiles.routes') },
            { path: 'admin/evaluaciones-rendimiento', loadChildren: () => import('app/modules/intranet/admin/performance-reviews/performance-reviews.routes') },
            // UVIE
            { path: 'uvie/clientes', loadChildren: () => import('app/modules/intranet/uvie/clients/uvie-clients.routes') },
            { path: 'uvie/establecimientos', loadChildren: () => import('app/modules/intranet/uvie/establishments/uvie-establishments.routes') },
            { path: 'uvie/preofertas', loadChildren: () => import('app/modules/intranet/uvie/pre-offers/uvie-pre-offers.routes') },
            { path: 'uvie/ofertas', loadChildren: () => import('app/modules/intranet/uvie/offers/uvie-offers.routes') },
        ]
    },

    // Broken URLs
    { path: '**', pathMatch: 'full', redirectTo: 'admin/perfiles' },
];
